import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NotificationRecord, NotificationTypeEnum } from '../models/notifications/notification-record';

@Injectable()
export class NotificationsService {
        constructor(private toastr: ToastrService) {
        }

    public clear()
    {
            this.toastr.clear();
    }

    public add(notification: NotificationRecord) {
            switch (notification.type)
        {
                case NotificationTypeEnum.Error:
                this.showError(notification.message);
                break;
            case NotificationTypeEnum.Success:
            case NotificationTypeEnum.Info:
                this.showSuccess(notification.message);
                break;
            case NotificationTypeEnum.Warning:
                this.showWarning(notification.message);
                break;
            default:
                this.showSuccess(notification.message);
                break;
        }
    }

    private showSuccess(message :string, title?: string) {
            this.toastr.success(message, title);
    }

    private showWarning(message: string, title?: string) {
            this.toastr.warning(message, title);
    }

    private showError(message: string, title?: string) {
            this.toastr.error(message, title);
    }
}